import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "login" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "field mb-5" }
const _hoisted_6 = { class: "control has-icons-left has-icons-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" })
], -1)
const _hoisted_9 = { class: "field mb-5" }
const _hoisted_10 = { class: "control has-icons-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "control has-text-centered" }
const _hoisted_14 = {
  key: 0,
  class: "has-text-danger has-text-centered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "can-cancel": false,
      "is-full-page": _ctx.fullPage
    }, null, 8, ["active", "is-full-page"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.$config.loginLogoUrl,
          class: "pt-2 pb-5"
        }, null, 8, _hoisted_4),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                class: "input",
                placeholder: "Courriel"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.email,
                  void 0,
                  { trim: true }
                ]
              ]),
              _hoisted_7,
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                class: "input",
                type: "password",
                placeholder: "Mot de passe"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args))),
                type: "submit",
                class: "button is-login"
              }, " Se connecter ")
            ])
          ]),
          (_ctx.fail)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.fail), 1))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}